/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddCatalogItemRequest,
  CoverageResponseDto,
  CreateServiceAreaDto,
  CreateWarehouseDto,
  OperatingAreaDto,
  UpdateCatalogItemRequest,
  UpdateWarehouseDto,
  WarehouseDto,
  WarehouseServiceAreaDto,
} from '../models/index';
import {
    AddCatalogItemRequestFromJSON,
    AddCatalogItemRequestToJSON,
    CoverageResponseDtoFromJSON,
    CoverageResponseDtoToJSON,
    CreateServiceAreaDtoFromJSON,
    CreateServiceAreaDtoToJSON,
    CreateWarehouseDtoFromJSON,
    CreateWarehouseDtoToJSON,
    OperatingAreaDtoFromJSON,
    OperatingAreaDtoToJSON,
    UpdateCatalogItemRequestFromJSON,
    UpdateCatalogItemRequestToJSON,
    UpdateWarehouseDtoFromJSON,
    UpdateWarehouseDtoToJSON,
    WarehouseDtoFromJSON,
    WarehouseDtoToJSON,
    WarehouseServiceAreaDtoFromJSON,
    WarehouseServiceAreaDtoToJSON,
} from '../models/index';

export interface AddCatalogItemOperationRequest {
    id: number;
    addCatalogItemRequest: AddCatalogItemRequest;
}

export interface AddServiceAreaRequest {
    id: number;
    createServiceAreaDto: CreateServiceAreaDto;
}

export interface CreateWarehouseRequest {
    createWarehouseDto: CreateWarehouseDto;
}

export interface DeleteWarehouseRequest {
    id: number;
}

export interface GetServiceAreasRequest {
    id: number;
}

export interface GetWarehouseByIdRequest {
    id: number;
}

export interface GetWarehouseCatalogRequest {
    id: number;
    query: string;
    page: string;
    pageSize: string;
}

export interface RemoveCatalogItemRequest {
    id: number;
    itemId: number;
}

export interface RemoveServiceAreaRequest {
    id: number;
    areaId: number;
}

export interface UpdateCatalogItemOperationRequest {
    id: number;
    itemId: number;
    updateCatalogItemRequest: UpdateCatalogItemRequest;
}

export interface UpdateWarehouseRequest {
    id: number;
    updateWarehouseDto: UpdateWarehouseDto;
}

/**
 * 
 */
export class WarehouseServiceApi extends runtime.BaseAPI {

    /**
     * Add a product to warehouse catalog
     */
    async addCatalogItemRaw(requestParameters: AddCatalogItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addCatalogItem().'
            );
        }

        if (requestParameters['addCatalogItemRequest'] == null) {
            throw new runtime.RequiredError(
                'addCatalogItemRequest',
                'Required parameter "addCatalogItemRequest" was null or undefined when calling addCatalogItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}/catalog/items`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCatalogItemRequestToJSON(requestParameters['addCatalogItemRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Add a product to warehouse catalog
     */
    async addCatalogItem(requestParameters: AddCatalogItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.addCatalogItemRaw(requestParameters, initOverrides);
    }

    /**
     * Add service area to warehouse
     */
    async addServiceAreaRaw(requestParameters: AddServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseServiceAreaDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling addServiceArea().'
            );
        }

        if (requestParameters['createServiceAreaDto'] == null) {
            throw new runtime.RequiredError(
                'createServiceAreaDto',
                'Required parameter "createServiceAreaDto" was null or undefined when calling addServiceArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}/service-areas`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateServiceAreaDtoToJSON(requestParameters['createServiceAreaDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseServiceAreaDtoFromJSON(jsonValue));
    }

    /**
     * Add service area to warehouse
     */
    async addServiceArea(requestParameters: AddServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseServiceAreaDto> {
        const response = await this.addServiceAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new warehouse
     */
    async createWarehouseRaw(requestParameters: CreateWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseDto>> {
        if (requestParameters['createWarehouseDto'] == null) {
            throw new runtime.RequiredError(
                'createWarehouseDto',
                'Required parameter "createWarehouseDto" was null or undefined when calling createWarehouse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateWarehouseDtoToJSON(requestParameters['createWarehouseDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseDtoFromJSON(jsonValue));
    }

    /**
     * Create a new warehouse
     */
    async createWarehouse(requestParameters: CreateWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseDto> {
        const response = await this.createWarehouseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete warehouse
     */
    async deleteWarehouseRaw(requestParameters: DeleteWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteWarehouse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseDtoFromJSON(jsonValue));
    }

    /**
     * Delete warehouse
     */
    async deleteWarehouse(requestParameters: DeleteWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseDto> {
        const response = await this.deleteWarehouseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get coverage status for supplier operating areas
     */
    async getCoverageStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CoverageResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/coverage`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CoverageResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get coverage status for supplier operating areas
     */
    async getCoverageStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CoverageResponseDto> {
        const response = await this.getCoverageStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get operating areas assigned to supplier (read-only)
     */
    async getOperatingAreasRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OperatingAreaDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/operating-areas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OperatingAreaDtoFromJSON));
    }

    /**
     * Get operating areas assigned to supplier (read-only)
     */
    async getOperatingAreas(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OperatingAreaDto>> {
        const response = await this.getOperatingAreasRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get service areas for warehouse
     */
    async getServiceAreasRaw(requestParameters: GetServiceAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WarehouseServiceAreaDto>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getServiceAreas().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}/service-areas`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WarehouseServiceAreaDtoFromJSON));
    }

    /**
     * Get service areas for warehouse
     */
    async getServiceAreas(requestParameters: GetServiceAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WarehouseServiceAreaDto>> {
        const response = await this.getServiceAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get warehouse by ID
     */
    async getWarehouseByIdRaw(requestParameters: GetWarehouseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getWarehouseById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseDtoFromJSON(jsonValue));
    }

    /**
     * Get warehouse by ID
     */
    async getWarehouseById(requestParameters: GetWarehouseByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseDto> {
        const response = await this.getWarehouseByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get catalog items for a warehouse
     */
    async getWarehouseCatalogRaw(requestParameters: GetWarehouseCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getWarehouseCatalog().'
            );
        }

        if (requestParameters['query'] == null) {
            throw new runtime.RequiredError(
                'query',
                'Required parameter "query" was null or undefined when calling getWarehouseCatalog().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling getWarehouseCatalog().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling getWarehouseCatalog().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['query'] != null) {
            queryParameters['query'] = requestParameters['query'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}/catalog`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get catalog items for a warehouse
     */
    async getWarehouseCatalog(requestParameters: GetWarehouseCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getWarehouseCatalogRaw(requestParameters, initOverrides);
    }

    /**
     * Get all warehouses for supplier organization
     */
    async getWarehousesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WarehouseDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WarehouseDtoFromJSON));
    }

    /**
     * Get all warehouses for supplier organization
     */
    async getWarehouses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WarehouseDto>> {
        const response = await this.getWarehousesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Remove a product from warehouse catalog
     */
    async removeCatalogItemRaw(requestParameters: RemoveCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeCatalogItem().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling removeCatalogItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}/catalog/items/{itemId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a product from warehouse catalog
     */
    async removeCatalogItem(requestParameters: RemoveCatalogItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.removeCatalogItemRaw(requestParameters, initOverrides);
    }

    /**
     * Remove service area from warehouse
     */
    async removeServiceAreaRaw(requestParameters: RemoveServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseServiceAreaDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling removeServiceArea().'
            );
        }

        if (requestParameters['areaId'] == null) {
            throw new runtime.RequiredError(
                'areaId',
                'Required parameter "areaId" was null or undefined when calling removeServiceArea().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}/service-areas/{areaId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"areaId"}}`, encodeURIComponent(String(requestParameters['areaId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseServiceAreaDtoFromJSON(jsonValue));
    }

    /**
     * Remove service area from warehouse
     */
    async removeServiceArea(requestParameters: RemoveServiceAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseServiceAreaDto> {
        const response = await this.removeServiceAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a warehouse catalog item
     */
    async updateCatalogItemRaw(requestParameters: UpdateCatalogItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateCatalogItem().'
            );
        }

        if (requestParameters['itemId'] == null) {
            throw new runtime.RequiredError(
                'itemId',
                'Required parameter "itemId" was null or undefined when calling updateCatalogItem().'
            );
        }

        if (requestParameters['updateCatalogItemRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCatalogItemRequest',
                'Required parameter "updateCatalogItemRequest" was null or undefined when calling updateCatalogItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}/catalog/items/{itemId}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"itemId"}}`, encodeURIComponent(String(requestParameters['itemId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCatalogItemRequestToJSON(requestParameters['updateCatalogItemRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a warehouse catalog item
     */
    async updateCatalogItem(requestParameters: UpdateCatalogItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateCatalogItemRaw(requestParameters, initOverrides);
    }

    /**
     * Update warehouse
     */
    async updateWarehouseRaw(requestParameters: UpdateWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WarehouseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateWarehouse().'
            );
        }

        if (requestParameters['updateWarehouseDto'] == null) {
            throw new runtime.RequiredError(
                'updateWarehouseDto',
                'Required parameter "updateWarehouseDto" was null or undefined when calling updateWarehouse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/warehouses/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWarehouseDtoToJSON(requestParameters['updateWarehouseDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WarehouseDtoFromJSON(jsonValue));
    }

    /**
     * Update warehouse
     */
    async updateWarehouse(requestParameters: UpdateWarehouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WarehouseDto> {
        const response = await this.updateWarehouseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
